import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "input-switch" }
const _hoisted_2 = {
  key: 0,
  class: "value flex-center-between"
}
const _hoisted_3 = { class: "text-lg" }
const _hoisted_4 = { class: "options flex-center flex-wrap" }
const _hoisted_5 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    false
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.value), 1),
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:value', null)))
          }, "X")
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option, i) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["option mr-1 bg-yellow-300 rounded px-2 text-sm text-gray-0 mb-1", {'hover:bg-yellow-400 cursor-pointer': !_ctx.disabled, 'bg-yellow-500': _ctx.isActive(option as any), 'hidden': _ctx.disabled && !_ctx.isActive(option as any)}]),
          key: i,
          onClick: ($event: any) => (_ctx.emit(option))
        }, [
          _createElementVNode("b", null, _toDisplayString(option.label || option), 1)
        ], 10, _hoisted_5))
      }), 128))
    ])
  ]))
}